<template>
  <div class="wrap-box">
    <div class="wrap-box-left">
      <div class="article-wrap" style="height: 100%;">
        <div v-if="riskDetail.riskTitle" class="centre_content nano" id="centre_contents">
          <div id="consult_left_content">
            <div class="table-top-box">
              <span class="fl left">{{ $t('label.information.risk.title') }}</span>
              <span class="fr right" @click="$router.back()"><Icon type="ios-arrow-back" style="color:#1e98d3;font-size: 20px;" />{{ $t('buttons.back') }}</span>
              <span class="fr right  div-xs-hidden" @click="exportDetail"><span class="word-png"></span>{{ $t('buttons.export') }}</span>
              <!-- <span class="fr right"><Icon type="md-star" style="font-size: 20px;"/></span> -->
              <span class="fr right "><Icon color="#008bce" @click="editFavorite" :type="riskDetail.favStatus ? 'md-star' : 'md-star-outline'" style="font-size: 20px;"/></span>
            </div>
        </div>
        <div class="nano-content p-4" id="spanblock" style="top:40px;padding-top: 0px !important;">
            <!--<p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>-->
            <h1 class="information_article_headline">{{ riskDetail.riskTitle | filterEmpty }}</h1>
            <p class="information_article_info">
              <span class="mr-2" v-if="riskDetail.time">{{ riskDetail.time| filterEmpty }} </span>
              <span v-if="riskDetail.author && riskDetail.author > 0">
              {{ $t('label.information.detail.author') }}
              <span class="mr-2">{{ riskDetail.author| filterEmpty }} </span>
            </span>
              <span v-if="riskDetail.source">{{ $t('label.information.detail.source') }}{{ riskDetail.source| filterEmpty }}</span>
          <p class="risk-detail-tags" v-if="riskDetail.riskLabel">
            <el-tag
                style="margin-right: 4px;"
                v-for="item in  riskDetail.riskLabel"
                :key="item"
                size="small"
                effect="plain">
              {{ item }}
            </el-tag>
          </p>
            <div class="information_article_abstract rounded" v-if="riskDetail.riskSummary">
              <p>{{ $t('label.information.detail.summary') }}{{ riskDetail.riskSummary }}</p>
            </div>
            <!-- 文章 -->
            <div class="risk-detail-timeline">
              <div class="timeline-item" v-for="(article, index) in riskDetail.riskArticleList" :key="index">
                <div class="timeline-item-node">
<!--                  <span v-if="index === 0" class="timeline-item-node-newest">最新</span>-->
                  <span class="timeline-item-node-text">{{ article.articleDate }}</span>
                </div>
                <div class="timeline-item-content">
                  <div class="timeline-item-circle-box">
                    <div class="timeline-item-out-circle">
                      <div class="timeline-item-in-circle" v-if="index === 0"></div>
                    </div>
                    <div class="timeline-item-line"></div>
                  </div>
                  <div class="timeline-item-title">
<!--                    <a v-if="article.sourceAddress" :href="article.sourceAddress">{{ article.articleTitle }}</a>-->
                    <el-link v-if="article.articleId" :underline="false" @click="$router.push({name:'pbrInfoDetail',query:{key:article.articleId}})">{{ article.articleTitle }}</el-link>
                    <span v-else>{{ article.articleTitle }}</span>
                  </div>
                  <p class="timeline-item-detail">{{ article.articleSummary }}</p>
                  <div class="timeline-item-tags">
                    <el-tag type="info" v-if="article.sourceType" size="small" effect="plain">{{ $t('label.information.detail.source') }}{{ article.sourceType }}</el-tag>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
<!--      <div class="table-top-box">-->
<!--        <span class="fl left">风险详情</span>-->
<!--        <span class="fr right" @click="$router.back()"><Icon type="ios-arrow-back" style="color:#1e98d3;font-size: 20px;" />返回</span>-->
<!--        <span class="fr right" @click="exportDetail"><span class="pdf-back"></span>导出PDF</span>-->
<!--         <span class="fr right"><Icon color="#008bce" @click="editFavorite" :type="riskDetail.favStatus ? 'md-star' : 'md-star-outline'" style="font-size: 20px;"/></span>-->
<!--      </div>-->
<!--      <div>-->
<!--        <div class="risk-detail-top">-->
<!--          <div class="risk-detail-top-img">-->
<!--             <img :src="riskDetail.pictureUrl || 'static/images/pbr/blank.png'" alt="">-->
<!--            &lt;!&ndash; <img v-if="riskDetail.picturePath" :src="riskDetail.picturePath" alt=""> &ndash;&gt;-->
<!--          </div>-->
<!--          <div class="risk-detail-top-content">-->
<!--            <h3 class="risk-detail-title">{{riskDetail.riskTitle}}</h3>-->
<!--            <p class="risk-detail-tags" v-if="riskDetail.riskLabel">-->
<!--              <el-tag-->
<!--                style="margin-right: 4px;"-->
<!--                v-for="item in  riskDetail.riskLabel"-->
<!--                :key="item"-->
<!--                size="small"-->
<!--                effect="plain">-->
<!--                {{ item }}-->
<!--              </el-tag>-->
<!--            </p>-->
<!--            <p class="risk-detail-summary line-clamp-ellipsis" :title="riskDetail.riskSummary">【摘要】{{riskDetail.riskSummary}}</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="risk-detail-timeline">-->
<!--          <div class="timeline-item" v-for="(article, index) in riskDetail.list" :key="index">-->
<!--            <div class="timeline-item-node">-->
<!--              <span v-if="index === 0" class="timeline-item-node-newest">最新</span>-->
<!--              <span v-else class="timeline-item-node-text">{{$moment(article.articleDate).format('MM-DD')}}</span>-->
<!--            </div>-->
<!--            <div class="timeline-item-content">-->
<!--              <div class="timeline-item-circle-box">-->
<!--                <div class="timeline-item-out-circle">-->
<!--                  <div class="timeline-item-in-circle" v-if="index === 0"></div>-->
<!--                </div>-->
<!--                <div class="timeline-item-line"></div>-->
<!--              </div>-->
<!--              <div class="timeline-item-title">{{article.articleTitle}}</div>-->
<!--              <p class="timeline-item-detail">{{article.articleSummary}}</p>-->
<!--              <div class="timeline-item-tags">-->
<!--                <el-tag type="info" size="small" effect="plain">来源：{{article.articleSource}}</el-tag></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="wrap-box-right">
      <div class="pbr-title">{{ $t('label.information.detail.informationAtlas') }}</div>
      <AtlasAnalysis :graph="graphData" id="riskDetailGraph"></AtlasAnalysis>
      <div class="pbr-title">{{ $t('label.information.risk.relatedEnterprises') }}</div>
      <normal-list :key="rkey" :page-size="6" :itemClick="RelatedEnterpriseClick" url="/front/risk/queryRelatedEnterprise" columns="['name']" :params="{id:$route.query.key, lang:'cn'}" listKey="" goto="pbrCompanyDetail" :columns="['name']"></normal-list>
    </div>
    <div v-show="false" ref="submitForm">
      <form
          method="get"
          target="_blank"
          enctype="multipart/form-data"
          :action="action"
      >
        <input name="id" type="text" />

        <input name="from" type="text" value="cn" />
      </form>
    </div>
  </div>
</template>

<script>
import NormalList from '../index/NormalList.vue'
import AtlasAnalysis from '../analysis/AtlasAnalysis'
import {contentType,exportFile} from '../apis/common'
export default {
  name: 'pbrRiskDetail',
  components: {NormalList,AtlasAnalysis},
  data () {
    return {
      self:this,
      graphData:{
        graph:{}
      },
      rkey: (new Date()).getTime(),
      riskDetail: {
        list: [{
          articleTitle: '1',
          articleSummary: '1',
          articleSource: '1',
          articleDate: '2020-02-02'
        }, {
          articleTitle: '2',
          articleSummary: '2',
          articleSource: '2',
          articleDate: '2020-02-02'
        }, {
          articleTitle: '3',
          articleSummary: '3',
          articleSource: '3',
          articleDate: '2020-02-02'
        }, {
          articleTitle: '4',
          articleSummary: '4',
          articleSource: '4',
          articleDate: '2020-02-02'
        }]
      },
      action:this.$pbrApis.exportRiskDetailWordUrl
    }
  },
  created () {
    this.fetchDetail()
  },
  mounted () {
    if (this.$route.query.key) {

    } else {
      this.$router.replace({name: 'pbrInfo'})
    }
  },
  activated () {
    if (this.$route.query.key) {
      this.fetchDetail()
      this.rkey = (new Date()).getTime()
      this.fetchGraphData()
    } else {
      // this.$iMessage.error({content: this.$t('message.warning.noId'), duration: 5, onClose:()=>{
      //
      //   }})
    }
  },
  methods: {
    /**
     * 风险事件图谱
     */
    fetchGraphData(){
      this.graphData.graph = {}
      if (!this.$route.query.key) {
        return
      }
      this.$pbrApis.getRelationMapRisk({id: this.$route.query.key, conceptId:'1', tag:'1', lang:'cn'}).then(res => {
        console.log('图谱', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.graphData.graph = res.result
        }
      })
    },
    /**
     * 获取详情
     */
    fetchDetail () {
      this.riskDetail = {}
      let self = this
      if (!this.$route.query.key) {
        return
      }
      this.$pbrApis.queryRiskDetail({params: {id: this.$route.query.key, lang: 'cn'}}).then(res => {
        console.log('风险事件详情', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          self.riskDetail = {...self.riskDetail, ...res.result}
        } else {
          //this.$iMessage.error(res.message)
        }
      }).catch(err => {
        //this.$iMessage.error(err)
      })
    },
    /**
     * 收藏
     */
    editFavorite () {
      if (!this.$route.query.key) {
        //this.$iMessage.error({content: this.$t('message.warning.noFavorite'), duration: 5})
        return
      }
      let type = this.riskDetail.favStatus ? 'delete' : 'add'

      this.$pbrApis.editFavorite(type, {id: this.$route.query.key, type: 4}).then(res => {
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.favorite'), duration: 5})
        } else if (res.code === 200) {
          console.log('收藏', res)
          //this.$iMessage.success({content: type === 'add' ? this.$t('message.success.favorite') : this.$t('message.success.unfavored'), duration: 5})
          this.fetchDetail()
        }
      }).catch(err => {
        //this.$iMessage.error({content: err.message, duration: 5})
      })
    },
    isSourceAddressValidate (value) {
      return value && value.length > 0 && value !== 'null'
    },
    exportDetail(){
      // let form = $(this.$refs.submitForm).find('form');
      // form.find("input[name='id']").val(this.$route.query.key);
      // form.submit();
      exportFile(this.action,{id: this.$route.query.key}, this.$t('label.export.risk') + this.riskDetail.riskTitle, contentType.word, '.docx')
    },
    RelatedEnterpriseClick(enterprise){
      this.$router.push({name: 'pbrCompanyDetail',
        params: enterprise,
        query: {
          key: enterprise.id,
          name: enterprise.name,
          t: new Date().getTime() / 1000 // 时间戳，刷新当前router
        }})
    }
  },
  watch: {

  },
  filters: {
    formatDate: function (value, vue) {
      // if (that.$moment(value).isValid()) {
      //   return that.$moment(value).format('yyyy-MM-DD')
      // }
      // return value
      if(value !== '--'){
        return vue.$moment(value).format('yyyy-MM-DD')
      }
      return value
    },
    filterEmpty: function (value) {
      if (!value || value.length === 0) {
        return '--'
      }
      return value
    },
    filterSymbol: (value) => {
      if (value && value.length > 0) {
        return value.replace(/[?？]{2,}/g, '').replace(/\n+/g, '\n')
      }
      return '--'
    }
  }

}
</script>
<style scoped>

</style>
